import React from 'react';
import { T } from '../lib/lang';

const LINKS = {
  level3: 'https://talkauthentic.io/level3',
  space: 'https://aimindset.org/ai-mindset-community',
  aimindsetSite: 'https://aimindset.org/',
  aimindsetChannel: 'https://t.me/ai_mind_set',
  ponchik: 'https://t.me/ponchiknews',
  ppprompt: 'https://t.me/ppprompt',
  video: 'https://youtu.be/vsRf07uC6DM',
};

export function Footer() {
  return (
    <footer className="border-t border-border py-16">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-10 md:grid-cols-[1.2fr_1fr] md:gap-14">
          <div>
            <h3 className="font-serif text-3xl font-light italic text-text">
              <T ru="продолжить разговор" en="continue the conversation" />
            </h3>
            <p className="mt-4 max-w-xl text-sm leading-7 text-muted">
              <T
                ru="если тебе близка идея «Be Your Own Guru» — начни с видео и попробуй базовый IFS + AI протокол."
                en="if “Be Your Own Guru” resonates — start with the video and try the baseline IFS + AI protocol."
              />
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={LINKS.level3}
                target="_blank"
                rel="noreferrer"
                className="rounded bg-text px-5 py-3 text-[11px] font-medium uppercase tracking-widest text-bg hover:opacity-90"
              >
                <T ru="TalkAuthentic · Level 3 ↗" en="TalkAuthentic · Level 3 ↗" />
              </a>
              <a
                href={LINKS.space}
                target="_blank"
                rel="noreferrer"
                className="rounded border border-border bg-bg/30 px-5 py-3 text-[11px] uppercase tracking-widest text-text hover:border-gold hover:text-gold"
              >
                <T ru="join {space} ↗" en="join {space} ↗" />
              </a>
              <a
                href={LINKS.aimindsetChannel}
                target="_blank"
                rel="noreferrer"
                className="rounded border border-border bg-bg/30 px-5 py-3 text-[11px] uppercase tracking-widest text-text hover:border-gold hover:text-gold"
              >
                <T ru="AI Mindset · канал ↗" en="AI Mindset · channel ↗" />
              </a>
              <a
                href={LINKS.aimindsetSite}
                target="_blank"
                rel="noreferrer"
                className="rounded border border-border bg-bg/30 px-5 py-3 text-[11px] uppercase tracking-widest text-text hover:border-gold hover:text-gold"
              >
                <T ru="AI Mindset · сайт ↗" en="AI Mindset · site ↗" />
              </a>
            </div>
          </div>

          <div className="rounded-xl border border-border bg-bg/30 p-6 backdrop-blur">
            <div className="text-[10px] uppercase tracking-[0.25em] text-dim">
              <T ru="links" en="links" />
            </div>
            <div className="mt-5 grid gap-3 text-sm">
              <FooterLink href={LINKS.video} label={{ ru: 'YouTube видео', en: 'YouTube video' }} />
              <FooterLink href={LINKS.ponchik} label={{ ru: '@ponchiknews', en: '@ponchiknews' }} />
              <FooterLink href={LINKS.ppprompt} label={{ ru: '@ppprompt', en: '@ppprompt' }} />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-border pt-8 text-[11px] text-dim">
          <div>
            <span className="text-muted">Ivanov</span> × AI Mindset
          </div>
          <div className="text-dim">
            <T ru="сделано в React + Tailwind" en="built with React + Tailwind" />
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, label }: { href: string; label: { ru: string; en: string } }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="flex items-center justify-between rounded border border-border bg-card/60 px-4 py-3 text-text transition-colors hover:border-gold hover:text-gold"
    >
      <T ru={label.ru} en={label.en} />
      <span className="text-dim">↗</span>
    </a>
  );
}
